import { useSelector } from 'react-redux';
import { AppState } from '../types';

export default function useIsReferralCheckoutV2(): boolean {
  const referralCode = useSelector((state: AppState) => state.storeShop.cart.referralCode);
  return !!referralCode;
}
